import styled from "styled-components";

export const FieldLabel = styled.label`
  font-size: 1rem;
  font-weight: bold;
  color: #0f4059;
`;
